module.exports = __webpack_public_path__ + "static/media/coro.fae45e76.jpg";